import { Link } from "react-router-dom"
import Navbar from "../components/Navbar"
import Footer from "../components/Footer"
import useIsMobile from "../hooks/useIsMobile"

export default function PrivacyPolicy() {
    const isMobile = useIsMobile()

    return (
        <div style={{ width: "100%", background: "white", fontFamily: "Inter, sans-serif", color: "#111827" }}>
            <Navbar />
            <section style={{ maxWidth: 800, margin: "0 auto", padding: isMobile ? "32px 20px 80px" : "60px 24px 120px" }}>
                <Link to="/" style={{ display: "inline-flex", alignItems: "center", gap: 6, color: "#6B7280", textDecoration: "none", fontSize: 15, fontWeight: 500, marginBottom: isMobile ? 24 : 40 }}>
                    ← Back to home
                </Link>
                <h1 style={{ fontSize: isMobile ? 36 : 52, fontWeight: 800, letterSpacing: "-0.04em", margin: "0 0 16px" }}>
                    Privacy Policy
                </h1>
                <p style={{ fontSize: 15, color: "#9CA3AF", marginBottom: isMobile ? 32 : 48 }}>Last updated: May 2026</p>

                <div style={{ fontSize: isMobile ? 16 : 18, color: "#374151", lineHeight: 1.8 }}>
                    <p>Welcome to Qwiztime.</p>
                    <p>Qwiztime provides educational diagnostic quizzes and sample assessments designed to help users understand skill gaps and readiness in various subjects.</p>

                    <h2 style={{ fontSize: isMobile ? 20 : 26, fontWeight: 700, margin: "40px 0 14px", color: "#111827" }}>Information We Collect</h2>
                    <p>When you use Qwiztime, we may collect:</p>
                    <ul style={{ paddingLeft: 24, marginTop: 12 }}>
                        <li style={{ marginBottom: 8 }}>Name or email address (if voluntarily provided)</li>
                        <li style={{ marginBottom: 8 }}>Quiz responses and assessment answers</li>
                        <li style={{ marginBottom: 8 }}>Basic usage analytics (such as pages visited and quiz interactions)</li>
                        <li style={{ marginBottom: 8 }}>Device/browser information automatically collected by standard web technologies</li>
                    </ul>

                    <h2 style={{ fontSize: isMobile ? 20 : 26, fontWeight: 700, margin: "40px 0 14px", color: "#111827" }}>How We Use Information</h2>
                    <p>We use collected information to:</p>
                    <ul style={{ paddingLeft: 24, marginTop: 12 }}>
                        <li style={{ marginBottom: 8 }}>Deliver quiz functionality</li>
                        <li style={{ marginBottom: 8 }}>Evaluate quiz responses</li>
                        <li style={{ marginBottom: 8 }}>Improve quiz quality and user experience</li>
                        <li style={{ marginBottom: 8 }}>Develop future diagnostic products and personalized feedback</li>
                        <li style={{ marginBottom: 8 }}>Respond to user inquiries or support requests</li>
                    </ul>
                    <p>We do not sell personal information.</p>

                    <h2 style={{ fontSize: isMobile ? 20 : 26, fontWeight: 700, margin: "40px 0 14px", color: "#111827" }}>Google Forms</h2>
                    <p>Some quizzes may currently be hosted using Google Forms or third-party services. Information submitted through those services may also be subject to their privacy policies and terms.</p>

                    <h2 style={{ fontSize: isMobile ? 20 : 26, fontWeight: 700, margin: "40px 0 14px", color: "#111827" }}>Cookies and Analytics</h2>
                    <p>Qwiztime may use cookies or analytics tools to understand traffic and improve the platform experience.</p>

                    <h2 style={{ fontSize: isMobile ? 20 : 26, fontWeight: 700, margin: "40px 0 14px", color: "#111827" }}>Data Security</h2>
                    <p>We take reasonable steps to protect submitted information, but no internet transmission or storage system can be guaranteed completely secure.</p>

                    <h2 style={{ fontSize: isMobile ? 20 : 26, fontWeight: 700, margin: "40px 0 14px", color: "#111827" }}>Educational Purpose Only</h2>
                    <p>Qwiztime assessments are designed for educational and informational purposes only. Results should not be considered professional certification, hiring decisions, academic evaluation, or official testing.</p>

                    <h2 style={{ fontSize: isMobile ? 20 : 26, fontWeight: 700, margin: "40px 0 14px", color: "#111827" }}>Third-Party Links</h2>
                    <p>The site may contain links to external services or platforms. We are not responsible for the content or privacy practices of third-party websites.</p>

                    <h2 style={{ fontSize: isMobile ? 20 : 26, fontWeight: 700, margin: "40px 0 14px", color: "#111827" }}>Children's Privacy</h2>
                    <p>Qwiztime is not intended for children under 13 without parental supervision.</p>

                    <h2 style={{ fontSize: isMobile ? 20 : 26, fontWeight: 700, margin: "40px 0 14px", color: "#111827" }}>Changes to This Policy</h2>
                    <p>We may update this Privacy Policy periodically. Updates will be posted on this page with a revised effective date.</p>

                    <h2 style={{ fontSize: isMobile ? 20 : 26, fontWeight: 700, margin: "40px 0 14px", color: "#111827" }}>Contact</h2>
                    <p>For questions about this Privacy Policy, contact us at <a href="mailto:listener@qwiztime.ai" style={{ color: "#2563EB", textDecoration: "none", fontWeight: 600 }}>listener@qwiztime.ai</a>.</p>
                </div>
            </section>
            <Footer />
        </div>
    )
}
